import React from "react";
import { Spin, Alert, Typography, Divider } from "antd";
export default function Payments(props) {
  console.log();
  const { Paragraph, Title, Text } = Typography;
  return (
    <div>
      {" "}
      <Spin spinning={false}>
        <Alert
          message={`Invoice will be sent to your email address : ${props.email}.`}
          description={
            <Paragraph>
              <Title level={4}>Payment Instructions</Title>
              <Text>
                Please complete your payment by clicking the "Confirm" button
                below. Once you confirm the purchase, you will receive an
                invoice from quickbooks@notification.intuit.com. Please check
                your spam folder if you do not see it in your inbox.
              </Text>

              <Title level={4}>Payment & Attendance Policy</Title>
              <Text>
                Please note: Entry to this event is strictly limited to
                registered attendees who have completed payment in full prior to
                the event. By proceeding with your registration, you acknowledge
                and agree to this policy.
              </Text>
            </Paragraph>
          }
          type="info"
          showIcon
        />
        <Divider />
        {/* <Form.Item
          name={"paymentMethod"}
          label="Pay by check or card?"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Radio.Group
            onChange={(e) => {
              setPaymentMethod(e.target.value);
            }}
          >
            <Radio.Button value="check">Check</Radio.Button>
            <Radio.Button value="card">Card</Radio.Button>
          </Radio.Group>
        </Form.Item> */}
        {/* {paymentMethod == "card" ? <PayByCard loading={loading} /> : <></>} */}
      </Spin>
    </div>
  );
}
